module.exports = "./app-dist/templates/compare.component.ac6c2cb2a67590c2044dace1a50c3f8a.html";